module.exports = __webpack_public_path__ + "img/bgR4.507b5ddd.png";